var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 101,
    fill: "none",
    viewBox: "0 0 142 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f16458",
    d: "m54.25 27.68-4.32 13.28H35.96l11.3 8.21-4.31 13.29 11.3-8.21 11.3 8.2-4.32-13.28 11.3-8.2H58.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m83.25 73.55-4.31 13.28H64.97l11.3 8.21-4.32 13.29 11.3-8.21 11.3 8.2-4.31-13.28 11.3-8.2H87.57zM129.8 45.22l-4.32 13.28h-13.97l11.3 8.21L118.5 80l11.3-8.21 11.3 8.2-4.32-13.28 11.3-8.2h-13.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f16458",
    d: "m93.37 35.78-3.86 11.88h-12.5l10.11 7.35-3.86 11.88 10.11-7.34 10.11 7.34-3.86-11.88 10.11-7.35h-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.37-2 89.51 9.89h-12.5l10.11 7.34-3.86 11.89 10.11-7.35 10.11 7.35-3.86-11.89 10.11-7.34h-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f16458",
    d: "m43.46 76.93-2.35 7.22h-7.6l6.15 4.46-2.35 7.23 6.15-4.47 6.14 4.47-2.35-7.23 6.15-4.46h-7.6zM125.75 14.87l-2.35 7.22h-7.6l6.15 4.47-2.34 7.22 6.14-4.47 6.15 4.47-2.35-7.23 6.14-4.46h-7.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h142v101H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.58fe3b3f3a02d6a232402698875ff8d3.svg";
export { ForwardRef as ReactComponent };